<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style src="./styles/style.scss" lang="scss"></style> 
<style src="./styles/style-custom.scss" lang="scss"></style>

<script src="https://unpkg.com/@popperjs/core@2"></script>

<script>

//import apiClient from '@brightoncromwell/portal-api/ApiClient';
const PortalApi = require("@brightoncromwell/portal-api");

export default {
  name: 'app',
    mounted() {
    console.log('Vue.app mounted');
    //PortalApi.ApiClient.instance.basePath = 'http://bungabunga.com/';
    //console.log(PortalApi.ApiClient.instance.basePath);
    //console.log(apiClient.basePath);
  }
}
</script>